import React from 'react';
import { LockIcon, DownloadIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer-section" className="py-20 md:py-32 px-4 bg-[#112240] relative overflow-hidden" data-id="element-88">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#D4A843] opacity-5 blur-[100px] rounded-full pointer-events-none" data-id="element-89" />

      <div className="max-w-3xl mx-auto text-center relative z-10 animate-fade-in-up delay-200" data-id="element-90">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#F1F5F9] leading-tight mb-8" data-id="element-91">
          Reclaim your focus and end the "Shame Spiral" for good.
        </h2>

        <p className="text-xl text-[#94A3B8] mb-10" data-id="element-92">
          Get the full ADHD Executive Function Toolkit today.
        </p>

        <div className="mb-10" data-id="element-93">
          <span className="text-6xl md:text-7xl font-bold text-[#D4A843] tracking-tight" data-id="element-94">
            $29
          </span>
          <p className="text-[#E8C96A] mt-2 font-medium" data-id="element-95">
            One-time investment. Instant digital delivery.
          </p>
        </div>

        <a href="https://thefeelgoodfinds.org/cart/42559360958526:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 w-full md:w-auto text-xl font-bold text-[#0B1A2E] bg-[#2DD4BF] rounded-xl overflow-hidden transition-all hover:scale-[1.02] hover:bg-[#14B8A6] hover:shadow-[0_0_30px_rgba(45,212,191,0.5)] focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:ring-offset-2 focus:ring-offset-[#112240] no-underline" data-id="element-96">
          <DownloadIcon className="w-6 h-6" data-id="element-97" />
          <span data-id="element-98">Download the Toolkit Now</span>
        </a>

        <div className="flex items-center justify-center gap-2 mt-6 text-[#64748B] text-sm" data-id="element-99">
          <LockIcon className="w-4 h-4" data-id="element-100" />
          <span data-id="element-101">Secure checkout. Instant digital delivery.</span>
        </div>
      </div>
    </section>;
}